import { SvgIcon } from '@mui/material';
import {
  SignalCellular1BarRounded,
  SignalCellular2BarRounded,
  SignalCellular3BarRounded,
  SignalCellular4BarRounded
} from '@mui/icons-material';

interface PaceIconProps {
  pace: number;
}

export const SignalIcon = ({ pace }: PaceIconProps) => {
  const renderIcon = (pace) => {
    switch (pace) {
      case 1:
        return <SignalCellular1BarRounded />;
      case 2:
        return <SignalCellular2BarRounded />;
      case 3:
        return <SignalCellular3BarRounded />;
      case 4:
        return <SignalCellular4BarRounded />;
    }
  };
  return <SvgIcon>{renderIcon(pace)}</SvgIcon>;
};
